import { useEffect, useRef } from "@wordpress/element";

type Axis = "x" | "y";

export const useDragScroll = (axis: Axis = "x") => {
	const ref = useRef<HTMLDivElement | null>(null);

	useEffect(() => {
		const el = ref.current;
		if (!el) return;

		let isDragging = false;
		let start = 0;
		let scrollStart = 0;

		const onMouseDown = (e: MouseEvent) => {
			isDragging = true;

			start = axis === "x" ? e.clientX : e.clientY;
			scrollStart = axis === "x" ? el.scrollLeft : el.scrollTop;

			document.body.style.userSelect = "none";
			document.body.style.cursor = "grabbing";
		};

		const onMouseMove = (e: MouseEvent) => {
			if (!isDragging) return;

			e.preventDefault();

			const current = axis === "x" ? e.clientX : e.clientY;
			const distance = current - start;

			if (axis === "x") {
				el.scrollLeft = scrollStart - distance;
			} else {
				el.scrollTop = scrollStart - distance;
			}
		};

		const onMouseUp = () => {
			isDragging = false;

			document.body.style.userSelect = "";
			document.body.style.cursor = "";
		};

		el.addEventListener("mousedown", onMouseDown);
		window.addEventListener("mousemove", onMouseMove, {
			passive: false,
		});
		window.addEventListener("mouseup", onMouseUp);

		return () => {
			el.removeEventListener("mousedown", onMouseDown);
			window.removeEventListener("mousemove", onMouseMove);
			window.removeEventListener("mouseup", onMouseUp);

			document.body.style.userSelect = "";
			document.body.style.cursor = "";
		};
	}, [axis]);

	return ref;
};
